import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import Card from "@mui/material/Card";
import CTable2 from "../../../basecomp/components/CTable2";
import CButton from "../../../basecomp/components/CButton3";
// import CDropDown from "../../../basecomp/components/CDropDown3";
import CDropDown2 from "../../../basecomp/components/CDropDown";
import CInput2 from "../../../basecomp/components/CInput2";
import PrintingVM from "../viewmodel/PrintingVM";
import CCarousel from "../../../basecomp/components/CCarousel";
import { AddPrintKeys } from "../../assets/VarConstants";
import CBackDrop from "../../../basecomp/components/CBackDrop";
import CDropDown from "../../../basecomp/components/CDropDown_label_printing";
import { Box } from "@mui/system";

const PrintingView = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    poOptions,
    matOptions,
    sizeOptions,
    sLocOptions,
    selectedSize,
    selectedSLoc,
    stickerData,
    handleStickerDataEdit,
    buttonJson,
    labelData,
    handleSizeChange,
    handleStorageLocationChange,
    handleButtonClick,
    infoHeadData,
    infoRowData,
    carouselImages,
    openCarousel,
    setOpenCarousel,
    isPrinting,
    setForceInput,
    forceInput,
    handelUserTyping,
  } = PrintingVM();

  return (
    <Grid
      item
      xs={10}
      sm={10}
      md={10}
      lg={10}
      xl={10}
      sx={{ margin: "6em 0.5em 0.5em 0.5em" }}
    >
      <Card sx={{ padding: isXs ? "1em .5em" : "1em 2.5em" }}>

        <CBackDrop cOpen={isPrinting} />

        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {poOptions && poOptions.length > 0 && !forceInput ? (
            <CDropDown
              cHelperText={t("purchase_order")}
              cData={poOptions}
              cOnChange={(value) =>
                handleStickerDataEdit(AddPrintKeys.PO_KEY)(value,"dropdown")
              }
              cFullWidth={true}
              // onUserTyping={() => setForceInput(true)}
              onUserTyping={handelUserTyping}
            />
          ) : (
            <CInput2
              cHintText={t("purchase_order")}
              cValue={stickerData[AddPrintKeys.PO_KEY]}
              cOnChange={(value) =>
                handleStickerDataEdit(AddPrintKeys.PO_KEY)(value,"input")
              }
              cFullWidth={true}
            />
          )}
          {matOptions && matOptions.length > 0 ? (
            <CDropDown
              cHelperText={t("material_number")}
              cData={matOptions}
              cOnChange={(value) =>
                handleStickerDataEdit(AddPrintKeys.MAT_NO_KEY)(value,"dropdown")
              }
              cFullWidth={true}
              cIsRequired={true}
            />
          ) : (
            <CInput2
              cHintText={t("material_number")}
              cValue={stickerData[AddPrintKeys.MAT_NO_KEY]}
              cOnChange={(value) =>
                handleStickerDataEdit(AddPrintKeys.MAT_NO_KEY)(value,"input")
              }
              cFullWidth={true}
              cIsRequired={true}
            />
          )}
          <Box sx={{display:"flex",width:"100%"}}>
          <CDropDown2
            cHelperText={t("size")}
            cData={sizeOptions.filter((item) => item.is_warehouse !== 1)}
            cIsOptionName="size"
            cOnChange={handleSizeChange}
            cFullWidth={true}
            cIsRequired={true}
            cDefaultValue={selectedSize}
          />
          <CDropDown2
            cHelperText={t("Storage Location")}
            cData={sLocOptions}
            cIsOptionName="sloc"
            cOnChange={handleStorageLocationChange}
            cFullWidth={true}
            cIsRequired={true}
            cDefaultValue={selectedSLoc}
          />
          
          </Box>
          <CInput2
            cHintText={t("quantity")}
            cValue={stickerData[AddPrintKeys.QUANTITY_KEY]}
            cOnChange={(value) =>
              handleStickerDataEdit(AddPrintKeys.QUANTITY_KEY)(value)
            }
            cFullWidth={true}
            cIsRequired={true}
            cType="quantity"
          />

          <Grid
            container
            spacing={2}
            marginBottom={8}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {Object.keys(buttonJson).map((key) => (
              <Grid item key={key}>
                <CButton
                  cSrc={buttonJson[key].src}
                  cTooltipText={buttonJson[key].tooltipText}
                  cOnClick={() => handleButtonClick(key)}
                  cFullWidth={true}
                  cDisabled={buttonJson[key].isDisabled}
                />
              </Grid>
            ))}
          </Grid>

          {labelData.length > 0 && (
            <CTable2
              cHeaderData={infoHeadData}
              cRowData={infoRowData}
              cActualData={labelData}
              cIsPagination={true}
              cSmallSize={true}
            />
          )}
          {openCarousel && (
            <CCarousel
              cOpen={openCarousel}
              images={carouselImages}
              cClose={() => setOpenCarousel(false)}
            />
          )}
        </Grid>
      </Card>
    </Grid>
  );
};

export default PrintingView;
